import { render, staticRenderFns } from "./EmSppWarehousingDetSwdEdit.vue?vue&type=template&id=50b13a70&"
import script from "./EmSppWarehousingDetSwdEdit.vue?vue&type=script&lang=js&"
export * from "./EmSppWarehousingDetSwdEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports